var map = {
	"./ADC-min.png": 3369,
	"./ADCE-min.png": 7401,
	"./Ad-Stars-min.png": 5082,
	"./CCA-min.png": 75,
	"./CSS-DA-min.png": 1510,
	"./Capes-min.png": 4489,
	"./Cresta-Award-min.png": 3111,
	"./Ebene-3-min.png": 7516,
	"./IAC-min.png": 336,
	"./LovieAwards-min.png": 7738,
	"./NewYorkFestival-min.png": 392,
	"./award_logo_german_design_award-min.png": 809,
	"./awwwards-logo-vector-min.png": 8543,
	"./eurobest2014_logo_black_nodate-min.png": 5809,
	"./iab-logo-about-min.png": 2305,
	"./logo-corporate-design-preis-473-min.png": 2666,
	"./logo-ddc-44-1-min.png": 80,
	"./logo-edawards-46-min.png": 179,
	"./logo-fwa-awards-min.png": 4894,
	"./logo-if-design-award-48-min.png": 8045,
	"./logo-the-webby-awards-min.png": 8993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;